<template>
  <div class="report">
    <div class="page-header-wrapper">
      <PageHeader title="Top Content View"></PageHeader>
      <el-form class="filter-wrapper" label-width="60px">
        <el-col :span="6" v-role="[1]">
          <el-form-item
            label="Role"
            prop="role"
          >
            <el-select
              v-model="form.role"
              placeholder="Please select Role"
              filterable
              @change="roleChange"
            >
              <el-option
                v-for="(item, idx) in roleOptions"
                :key="idx"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-role="[1]">
          <el-form-item
            label="Leader"
            prop="taId"
          >
            <el-select
              v-model="form.taId"
              placeholder="Please select Leader"
              filterable
              @change="taChange"
            >
              <el-option
                v-for="(item, idx) in taOptions"
                :key="idx"
                :label="item.TAName"
                :value="item.TAID"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="filterSpan">
          <el-form-item label="Team" prop="teamId">
            <el-select
              v-model="form.teamId"
              placeholder="Please select Team"
              filterable
            >
              <el-option
                v-for="(item, idx) in teamOptions"
                :key="idx"
                :label="item.TeamName"
                :value="item.TeamID"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="filterSpan">
          <el-form-item label="Year" label-width="60px">
            <el-select v-model="form.year" placeholder="Please select year">
              <el-option
                v-for="item in yearsOptions"
                :key="item.Year"
                :label="item.Year"
                :value="item.Year"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="filterSpan">
          <el-form-item label="Month">
            <el-select
              class="month-select"
              ref="monthSelect"
              v-model="form.month"
              placeholder="Please select month"
              multiple
              v-multiple-tip
              @change="monthSelectChange"
            >
              <el-option
                v-for="item in monthOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="filterSpan">
          <el-form-item label="Type" prop="type">
            <el-select
              v-model="form.type"
              placeholder="Please select type"
            >
              <el-option label="All" value=""/>
              <el-option label="Content Push" value="ContentMeetingPush"/>
              <el-option label="Quick Push" value="QuickPush"/>
            </el-select>
          </el-form-item>
        </el-col>
        <div class="query-action">
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getTableData()"
            :disabled="queryable"
          >
            Query
          </el-button>
          <el-button
            type="primary"
            icon="iconfont icon-export"
            @click="getTableData(true)"
            :disabled="exportable"
            :loading="exporting"
          >
            Export
          </el-button>
        </div>
      </el-form>
    </div>
    <div class="charts" ref="charts" v-role="[1, 2, 4, 6, 8, 10, 12]">
      <div
        v-show="!histChartDataEmpty"
        class="chart"
        ref="noOfContent"
        :style="chartStyle"
      ></div>
      <div class="empty-placeholder" v-show="histChartDataEmpty">
        <span class="empty-title">Top 20 Contents</span>
        <div class="chart empty">
          <span>No Data</span>
        </div>
      </div>
    </div>
    <div class="table-wrapper">
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        element-loading-text="Loading..."
      >
        <el-table-column
          prop="DocumentTitle"
          label="Content Title"
          min-width="150"
        />
        <el-table-column
          prop="SearchTerm"
          label="Search Term"
          min-width="150"
        />
        <el-table-column prop="CategoryName" label="Category" min-width="150" />
        <el-table-column prop="MLName" label="User" min-width="90" />
        <el-table-column prop="TaConfigName" label="TA" min-width="130" />
        <el-table-column prop="CNT_Push" label="No. Of Push" width="110" />
        <el-table-column prop="CNT" label="No. Of Hits" width="100" />
        <el-table-column label="Operation" width="120" align="center">
          <template slot-scope="{ row }">
            <el-button
              class="view-bnt"
              type="text"
              icon="iconfont icon-read"
              @click="handleViewPaper(row)"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <ViewPaperDialog
      :visible.sync="viewPaperDialogVisible"
      :data.sync="rowData"
    />
  </div>
</template>

<script>
import {
  addResizeListener,
  removeResizeListener,
} from "element-ui/src/utils/resize-event";
import * as echarts from "echarts/core";
import { BarChart } from "echarts/charts";
import {
  GridComponent,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components";
import { SVGRenderer } from "echarts/renderers";
echarts.use([
  GridComponent,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  BarChart,
  SVGRenderer,
]);
import downloadjs from "downloadjs";
import moment from "moment";
import ViewPaperDialog from "../se/view/view-paper-dialog";
import {RoleCode} from "@/utils/role-constant";
export default {
  name: "Top-Content-View",
  components: { ViewPaperDialog },
  data() {
    return {
      tableLoading: true,
      exporting: false,
      tableData: [],
      form: {
        role: "",
        taId: "",
        teamId: "",
        year: moment().year(),
        month: [moment().month() + 1],
        type: ""
      },
      roleList: [],
      taList: [],
      teamList: [],
      otherList: null,
      monthOptions: [
        {
          label: "All",
          value: "",
        },
      ],
      queryable: true,
      exportable: true,
      histChart: null,
      histChartDataEmpty: false,
      loadingOption: {
        text: "loading...",
        color: "#d52b1e",
        lineWidth: 2,
      },
      chartHeight: 80,
      yAxisData: [],
      viewPaperDialogVisible: false,
      rowData: null,
      resizeListener: null,
    };
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
    filterSpan(){
      return this.role === 1 ? 6 : 5;
    },
    isShowCharts() {
      return this.role === RoleCode.Admin ||
        this.role === RoleCode.Supervisor ||
        this.role === RoleCode.TALead ||
        this.role === RoleCode.CRPLeader ||
        this.role === RoleCode.CVEOLeader ||
        this.role === RoleCode.SciComLeader ||
        this.role === RoleCode.ClinTransLeader;
    },
    teamName() {
      let team = this.teamList.find((item) => item.TeamID === this.form.teamId);
      return team ? team.TeamName : "";
    },
    roleOptions() {
      return [{value:"",name:"All"}].concat(this.roleList);
    },
    taOptions() {
      return [{ TAName: "All", TAID: "", RoleName: "" }].concat(
          this.taList.filter(({RoleName}) => {
            return this.form.role ? this.form.role === "MSL" ? RoleName === "TALead" : RoleName.indexOf(this.form.role) > -1 : true;
          })
        );
    },
    teamOptions() {
      let options = this.teamList.filter(({TAID, RoleName}) => {
        return this.form.taId ? this.form.taId === TAID
          : ( RoleName.indexOf(this.form.role) > -1 || (this.form.role === "MSL" && (RoleName === "TALead" || RoleName === "Supervisor")))
      });
      return this.role === 1 || this.role === 4 ? [{ TeamName: "All", TeamID: "", RoleName: "" }].concat(options) : options;
    },
    yearsOptions() {
      return this.otherList ? this.otherList.year : [];
    },
    chartStyle() {
      return {
        height: `${this.chartHeight}px`,
      };
    },
    colors() {
      return [
        "#ffef9c",
        "#f6ec9a",
        "#eee998",
        "#e6e796",
        "#dee495",
        "#d5e293",
        "#cddf91",
        "#c5dc8f",
        "#bdda8e",
        "#b5d78c",
        "#acd58a",
        "#a4d288",
        "#9cd087",
        "#94cd85",
        "#8cca83",
        "#83c881",
        "#7bc580",
        "#73c37e",
        "#6bc07c",
        "#63be7b",
      ];
    },
  },
  mounted() {
    if (this.isShowCharts) {
      this.renderCharts();
      this.resizeListener = echarts.throttle(() => {
        if (this.$options.name === this.$route.meta.title) {
          this.onResize();
          this.$nextTick(() => {
            this.renderCharts(true);
          });
        }
      }, 100);
      addResizeListener(this.$refs.charts, this.resizeListener);
    }
  },
  beforeDestroy() {
    if (this.isShowCharts && this.resizeListener) {
      removeResizeListener(this.$refs.charts, this.resizeListener);
    }
  },
  created() {
    this.getData();
    this.bus.$on("refresh", ({ name }) => {
      if (this.$options.name === name) {
        this.getData();
      }
    });
    this.bus.$on("onSideMenuCollapse", () => {
      if (this.$options.name === this.$route.meta.title) {
        echarts.throttle(() => {
          this.renderCharts(true);
        }, 200);
      }
    });
    for (let i = 1; i <= 12; i++) {
      this.monthOptions.push({
        label: i,
        value: i,
      });
    }
  },
  activated() {
    this.onResize();
    this.$nextTick(() => {
      this.renderCharts(true);
    });
  },
  methods: {
    roleChange() {
      this.form.taId = "";
      this.form.teamId = "";
    },
    taChange() {
      this.form.teamId = "";
    },
    monthSelectChange(value) {
      const filter = (val) => val === "";
      const index = value.findIndex(filter);
      const isAll = value.some(filter);
      this.form.month = value.filter((val) => {
        return isAll && (index !== 0 || value.length === 1)
          ? val === ""
          : val !== "";
      });
      if (value.length === 0) {
        this.form.month = [""];
      }
    },
    onResize() {
      if (this.$route.meta.title === this.$options.name) {
        this.histChart && this.histChart.resize();
      }
    },
    renderCharts(hideLoading = false) {
      this.renderHitsChart();
      if (hideLoading) {
        this.histChart && this.histChart.hideLoading();
      }
    },
    renderHitsChart() {
      let yAxisData = [];
      let data = [];
      this.tableData.forEach((item, index) => {
        yAxisData.push(`${index + 1}   ${item.DocumentTitle}`);
        data.push(item.CNT);
      });
      this.histChartDataEmpty = data.length === 0;
      for (let i = yAxisData.length - 1; yAxisData.length < 20; i++) {
        yAxisData.push("");
      }
      yAxisData.reverse();
      for (let i = data.length - 1; data.length < 20; i++) {
        data.push(0);
      }
      data.reverse();
      this.chartHeight = data.length * 20 + 80;
      const option = {
        title: {
          text: "Top 20 Contents",
          left: "center",
          textStyle: {
            color: "#000000",
            fontSize: 14,
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line",
          },
          confine: true,
          formatter([params]) {
            return params.axisValue !== ""
              ? `<span>${params.axisValue.split("   ")[1]}</span>`
              : "";
          },
        },
        grid: {
          top: 30,
          left: 20,
          right: "35%",
          bottom: 40,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
          axisTick: {
            alignWithLabel: true,
          },
          axisLine: {
            show: true,
          },
        },
        yAxis: {
          show: true,
          axisTick: {
            alignWithLabel: true,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
            },
          },
          position: "right",
          axisLine: {
            show: false,
          },
          axisLabel: {
            fontWeight: "bold",
            color: "#333333",
            width:
              this.histChart !== null ? this.histChart.getWidth() * 0.32 : 0,
            overflow: "truncate",
            formatter(value) {
              if (value === "") {
                return;
              }
              let strs = value.split("   ");
              let type = "d";
              switch (parseInt(strs[0])) {
                case 1:
                  type = "a";
                  break;
                case 2:
                  type = "b";
                  break;
                case 3:
                  type = "c";
                  break;
              }
              return `{${type}|${strs[0]}}${strs[1]}`;
            },
            rich: {
              a: {
                color: "#FE2D46",
                fontWeight: 800,
                width: 30,
              },
              b: {
                color: "#FF6600",
                fontWeight: 800,
                width: 30,
              },
              c: {
                color: "#FAA90E",
                fontWeight: 800,
                width: 30,
              },
              d: {
                color: "#c4c7ce",
                fontWeight: 800,
                width: 30,
              },
            },
          },
          data: yAxisData,
        },
        series: [
          {
            name: "Hits",
            type: "bar",
            data: data,
            label: {
              show: true,
              position: "right",
              formatter(item) {
                return item.name !== "" ? item.value : "";
              },
            },
            itemStyle: {
              color: (params) => {
                return this.colors[params.dataIndex];
              },
            },
          },
        ],
      };

      if (!this.histChart) {
        this.histChart = echarts.init(this.$refs.noOfContent, null, {
          renderer: "svg",
        });
        this.histChart.showLoading(this.loadingOption);
      }
      this.histChart.setOption(option);
      this.$nextTick(() => {
        this.onResize();
      });
    },
    getData() {
      Promise.all([
        this.axios.get(`analytics/otherList`),
        this.axios.get(`analytics/taList`),
        this.axios.get("analytics/teamList"),
        this.axios.get(`analytics/roleList`)
      ]).then((res) => {
        this.getOtherList(res[0]);
        this.getTAList(res[1]);
        this.getTeamList(res[2]);
        this.getRoleList(res[3]);
        this.queryable = false;
        this.exportable = false;
        this.getTableData();
      });
    },
    getRoleList({ code, data, msg }){
      if (200 === code) {
        this.roleList = data;
        if (this.role === RoleCode.Supervisor || this.role === RoleCode.TALead) {
          const { value } = data[0] || { value:"" };
          this.form.role = value;
        } else {
          const roleName = this.$store.state.userInfo.roleName;
          const { value } = this.roleList.find(({value}) => roleName.indexOf(value)>-1) || { value:"" };
          this.form.role = value;
        }
      } else {
        this.$message.error(msg);
      }
    },
    getOtherList({ code, data, msg }) {
      if (200 === code) {
        this.otherList = data;
      } else {
        this.$message.error(msg);
      }
    },
    getTAList({ code, data, msg }) {
      if (200 === code) {
        this.taList = data;
        if (this.role === 4) {
          this.form.taId = data.length > 0 ? data[0].TAID : "";
        }
      } else {
        this.$message.error(msg);
      }
    },
    getTeamList({ code, data, msg }) {
      if (200 === code) {
        this.teamList = data;
        if (this.role == RoleCode.Supervisor
          || this.role == RoleCode.CRPLeader
          || this.role == RoleCode.CVEOLeader
          || this.role == RoleCode.SciComLeader
          || this.role == RoleCode.ClinTransLeader) {
          this.form.teamId = data.length > 0 ? data[0].TeamID : "";
        }
      } else {
        this.$message.error(msg);
      }
    },
    getTableData(exportable = false) {
      this.tableLoading = !exportable;
      this.exporting = exportable;
      if (this.isShowCharts && !exportable) {
        this.histChartDataEmpty = false;
        this.$nextTick(() => {
          this.onResize();
        });
      }
      const month = this.form.month.filter((value) => value !== "");
      let params = {
        ...this.form,
        month: month.toString(),
        exportable: exportable ? 1 : 0,
      };
      if (exportable) {
        Object.assign(params, {
          teamName: this.teamName,
        });
      }
      this.axios
        .get(`analytics/hitsFrequency`, {
          params: params,
          responseType: exportable ? "blob" : "json",
        })
        .then(({ code, data, msg }) => {
          if (exportable) {
            downloadjs(data.file, data.fileName, "application/vnd.ms-excel");
            this.exporting = false;
          } else {
            if (200 === code) {
              this.tableData = data;
              this.tableLoading = false;
              this.renderCharts(true);
            } else {
              this.$message.error(msg);
            }
          }
        })
        .catch(() => {
          this.exporting = false;
        });
    },
    handleViewPaper(row) {
      this.rowData = { ...row, IsQuickPush: !row.CategoryName };
      this.viewPaperDialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-wrapper {
  padding-top: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: inherit !important;
  flex-wrap: wrap;
  padding: 0 !important;
  .el-form-item {
    margin-bottom: 10px !important;
    .el-select {
      width: 100%;
    }
  }
  .query-action {
    flex: 1;
    margin-bottom: 10px;
    margin-left: 10px;
    white-space: nowrap;
    text-align: right;
  }
}
.charts {
  padding-top: 15px;
  margin-bottom: 15px;
  display: flex;
  border-radius: 10px;
  background-color: #fff;
  .chart {
    width: 100%;
    height: 400px;
    &.empty {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #909399;
    }
  }
}
.view-bnt {
  padding: 0;
}
</style>